<script>
  import { onMount } from 'svelte';
  import BookingDetails from '../ManageBookings/BookingDetails.svelte';
  import { getItineraryByPNR } from '../../http/itineraries';
  import {
    manageBookingsItinerary,
    hasManageBookingsItinerary,
    settings
  } from '../../store/index.js';

  export let pnr = undefined;

  let bookingDetailsConfig = undefined;

  function getItinerary() {
    const _manageBookingsItinerary = hasManageBookingsItinerary(pnr);

    getItineraryByPNR(pnr)
      .then((response) => {
        $manageBookingsItinerary = response.data
      })
      .catch(() => {
        $manageBookingsItinerary = undefined
      })
  }

  function onApprovalUpdated() {
    $manageBookingsItinerary = undefined;
    getItinerary();
  }

  onMount(() => {
    $manageBookingsItinerary = undefined;
    
    bookingDetailsConfig = {
      orderNumberLabel: $settings.OrderNumber.DisplayName,
      agencyReasonCodesLabel: $settings.AgencyReasonCodes.DisplayName
    };

    getItinerary();
  });
</script>

<BookingDetails isPta="{false}" itinerary="{ $manageBookingsItinerary }" settings="{ bookingDetailsConfig }"
  on:goToManageBookings on:goToSeatmaps on:approvalUpdated="{onApprovalUpdated}">
</BookingDetails>
